import React, {Component} from 'react';
import '../../App.css';
// import {TableColumnPopupType} from '../Popup/TableColumnPopup';
// import { getLocalisedText } from '../../Translate/LanguageManager';
// import AppManager from '../../Manager/AppManager';
// import Utility from '../../Utilities/Utility';

import {
    Utility,
    AppManager,
    getLocalisedText,
    TableColumnPopupType
} from 'deskera-doc-builder-lib'
export default class FulfillmentColumnEditor extends Component {

    dataChanged(data) {
        this.props.dataChanged(this.props.data);
    }

    render() {
        return this.getFulfillmentColumns(this.props.columnData)
    }

    getFulfillmentColumns(columnsData = []) {
        var arr = [];
        for (let i = 0; i < columnsData.length; i++) {
            arr.push(this.getFulfillmentColumn(i, columnsData[i]));
        }
        return arr;
    }

    getFulfillmentColumn(index, columnData) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >
                {this.getShowHideValueForTablePopup(TableColumnPopupType.code) && this.getColumnTextfields(
                    "sn_number",
                    index,
                    columnData.code,
                    this.columnSnNumberChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.productName) && this.getColumnTextfields(
                    "products",
                    index,
                    columnData.name,
                    this.columnNameChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.description) && this.getColumnTextfields(
                    "description",
                    index,
                    columnData.description,
                    this.columnDescriptionChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.uom) && this.getColumnTextfields(
                    "uom",
                    index,
                    columnData.uom,
                    this.columnUOMChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.serialBatch) && this.getColumnTextfields(
                    "serial_batch",
                    index,
                    columnData.serialBatch,
                    this.columnSerialBatchChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.requiredQuantity) && this.getColumnTextfields(
                    "required_qty",
                    index,
                    columnData.requiredQuantity,
                    this.columnRequiredQtyChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.committedQuantity) && this.getColumnTextfields(
                    "committed_qty",
                    index,
                    columnData.committedQuantity,
                    this.columnCommittedQtyChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.warehouseCode) && this.getColumnTextfields(
                    "warehouse_code",
                    index,
                    columnData.warehouseCode,
                    this.columnWarehouseCodeChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.warehouseName) && this.getColumnTextfields(
                    "warehouse_name",
                    index,
                    columnData.warehouseName,
                    this.columnWarehouseNameChanged,
                )}

                <div className='RowDiv'
                    style={{
                        flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                    }}>
                    <button
                        style={{
                            marginTop: 10,
                            cursor: "pointer",
                            color: "red",
                            border: "solid",
                            borderWidth: 1,
                            borderColor: "rgb(210, 210, 210)",
                            backgroundColor: "white",
                            borderRadius: 4,
                            marginBottom: 20,
                        }}
                        onClick={() => this.deleteColumn(index)}
                    >
                        {getLocalisedText("delete")}
                    </button>
                </div>
            </div>
        );
    }

    deleteColumn(index) {
        var data = this.props.data;
        data["lineItems"].splice(index, 1);
        this.dataChanged(data);
    }

    getColumnTextfields(placeholder, index, value, callback) {
        return (
            <input
                className="TextField"
                style={{
                    marginTop: 6,
                    borderRadius: 4,
                    color: 'rgb(30, 30, 30)'
                }}
                placeholder={getLocalisedText(placeholder)}
                type="text"
                dir={Utility.getInputDirection()}
                value={getLocalisedText(value)}
                onChange={(e) => callback(e, index)}
            />
        );
    }

    columnSnNumberChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["code"] = event.target.value;
        this.dataChanged(data);
    };

    columnNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["name"] = event.target.value;
        this.dataChanged(data);
    };

    columnDescriptionChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["description"] = event.target.value;
        this.dataChanged(data);
    };

    columnSerialBatchChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["serialBatch"] = event.target.value;
        this.dataChanged(data);
    };

    columnUOMChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["uom"] = event.target.value;
        this.dataChanged(data);
    };

    columnWarehouseCodeChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["warehouseCode"] = event.target.value;
        this.dataChanged(data);
    };

    columnWarehouseNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["warehouseName"] = event.target.value;
        this.dataChanged(data);
    };

    columnRequiredQtyChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["requiredQuantity"] = value;
        this.dataChanged(data);
    };

    columnCommittedQtyChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["committedQuantity"] = value;
        this.dataChanged(data);
    };

    getShowHideValueForTablePopup(tableColumnPopupType) {
        var item = AppManager.getTableColumnOptions(this.props.data.tableColumnPopup, tableColumnPopupType)
        if(item === undefined || item  === null) {
            return false
        }
        else {
            return item.isSelected
        }
    }

}
